import type { KeyPassage } from "../api";

export function KeyPassagesSection({ passages }: { passages: KeyPassage[] }) {
  return (
    <div className="flex flex-col gap-9">
      {passages.map((p, i) => (
        <article key={i} className="relative pl-8 md:pl-12">
          <span
            className="absolute left-0 top-0 font-serif italic text-gold/60 select-none leading-none"
            style={{ fontSize: "4rem" }}
          >
            “
          </span>
          <blockquote className="font-serif italic text-xl md:text-2xl text-plum leading-snug pr-2">
            {p.quote}
          </blockquote>
          <div className="mt-3 text-[0.7rem] uppercase tracking-[0.18em] text-gold-dark">
            {p.location}
          </div>
          <p className="mt-2 text-plum-soft leading-relaxed">{p.whyItMatters}</p>
        </article>
      ))}
    </div>
  );
}
